/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Step_ImportInputs */



/**
* | output |
* | --- |
* | "Import" |
*
* @param {Team_Manager_Import_Step_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_step_import = /** @type {((inputs?: Team_Manager_Import_Step_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Step_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Import")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読み込み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इंपोर्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar")
	return /** @type {LocalizedString} */ ("Import")
});